function Footer() {
  return (
    <div className="bg-slate-700 py-6">
      <footer className="content-xl flex items-center justify-between">
        <div className="text-white">
          <div>
            E-mail : <span className="ml-4">neros12@naver.com</span>
          </div>
          <div>Copyright © 2023 NewSeo.ME</div>
        </div>
        <a href="https://github.com/neros12" target="_blank" rel="noreferrer">
          <div className="flex flex-col items-center">
            <div className="w-10 space-y-1">
              <img src="/Images/Profile-Icons/github-mark-white.png" />
            </div>
            <div className="w-20">
              <img src="/Images/Profile-Icons/GitHub_Logo_White.png" />
            </div>
          </div>
        </a>
      </footer>
    </div>
  );
}

export default Footer;
